
import startApp from "../../entry";
import downloadPage from "./download.vue";

startApp(downloadPage);
